<script lang="ts">
  export let svgStyles: string = ''
  export let fillStyles: string = ''
</script>

<svg width="60" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg" class={svgStyles}>
  <rect x="0.5" width="30" height="30" rx="15" fill={fillStyles} />
  <path
    d="M20.5 10.375L20.0833 10C16.4586 11.2004 14.4647 11.4668 11 10.9V12.175C14.5664 12.2518 16.4228 12.0372 19.3333 10.9C15.6605 13.6743 13.7398 15.3076 10.5 18.325L11.25 19C14.7016 15.9453 16.5288 14.2052 19.5833 11.05C18.2412 13.5803 18.1436 15.2249 18.0833 18.55H19.4167C18.9367 15.3406 19.215 13.5514 20.5 10.375Z"
    fill="white"
  />
</svg>
